import BaseButton, { ButtonProps } from '@portalterreno/react-ui-core/Button';
import React from 'react';

export type SubmitButtonBaseProps = ButtonProps;

const SubmitButtonBase: React.FC<SubmitButtonBaseProps> = ({
  children,
  ...props
}) => {
  return (
    <BaseButton
      {...props}
      disabled={props.disabled}
    >
      {children}
    </BaseButton>
  );
};

export default SubmitButtonBase;
